export default __webpack_public_path__ + "static/media/gucci_bloom.efeb8b1e.png";